import {Component, Input} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Inlandsadresse} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
    selector: 'common-ui-inlandsadresse',
    templateUrl: './inlandsadresse.component.html'
})
export class InlandsadresseComponent extends FormBaseComponent<Inlandsadresse> {

    @Input()
    public showInlandsAdresse: boolean;
    @Input()
    public inlandOrtLocalzation: string;
    @Input()
    public inlandRequiredStrasse = false;
    @Input()
    public inlandRequiredHausnumer = false;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                private readonly translateService: TranslateService,
                protected readonly messageService: DatevMessageService) {
        super(messageService);
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            strasse: [this.data.strasse, [
                this.validatorService.conditionalValidator(() => this.inlandRequiredStrasse === true, this.validatorService.required()),
                this.validatorService.maxLength(72)
            ]],
            hausnummer: [this.data.hausnummer, [
                this.validatorService.conditionalValidator(() => this.inlandRequiredHausnumer === true, this.validatorService.required()),
                this.validatorService.maxLength(4),
                this.validatorService.pattern('^[1-9][0-9]*$',
                    this.translateService.instant('COMMON_UI.VALIDATION.HAUSNUMMER_INVALID_PATTERN'))
            ]],
            hausnummernzusatz: [this.data.hausnummernzusatz, [
                this.validatorService.maxLength(20)
            ]],
            adressergaenzung: [this.data.adressergaenzung, [
                this.validatorService.maxLength(46)
            ]],
            postleitzahl: [this.data.postleitzahl, [
                this.validatorService.required(),
                this.validatorService.pattern('^[0-9]{5,5}$',
                    this.translateService.instant('COMMON_UI.VALIDATION.PLZ_INVALID_PATTERN'))
            ]],
            ort: [this.data.ort, [
                this.validatorService.required(),
                this.validatorService.maxLength(72),
                this.validatorService.pattern('^[^\\d]*$',
                    this.translateService.instant('COMMON_UI.VALIDATION.ORT_INVALID_PATTERN'))
            ]]
        });
    }
}
